import { UserExternalWalletsProvider } from '@trustpad/launchpad';

import { Layout } from '~common/Layout';
import { UserAccountPage } from '~features/account/UserAccountPage';
import { getExternalWallets } from '~features/pools/components/BuyFromWrapper/BuyFormWrapper';

export default function Account() {
  return (
    <Layout navbarVisibility={{ account: false }}>
      <UserExternalWalletsProvider fetch={true} getWallets={getExternalWallets}>
        <UserAccountPage />
      </UserExternalWalletsProvider>
    </Layout>
  );
}
